import { render, staticRenderFns } from "./RecruitShareDetailDialog.vue?vue&type=template&id=18efffea&scoped=true&"
import script from "./RecruitShareDetailDialog.vue?vue&type=script&lang=js&"
export * from "./RecruitShareDetailDialog.vue?vue&type=script&lang=js&"
import style0 from "./RecruitShareDetailDialog.vue?vue&type=style&index=0&id=18efffea&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18efffea",
  null
  
)

export default component.exports